export default __webpack_public_path__ + "static/GT-America-Standard-Bold-c530e21a8caa3649173f859cb7900898.woff2";